import { render, staticRenderFns } from "./tianbaoxiangqingLess.vue?vue&type=template&id=5a5bcb91&scoped=true"
import script from "./tianbaoxiangqingLess.vue?vue&type=script&lang=js"
export * from "./tianbaoxiangqingLess.vue?vue&type=script&lang=js"
import style0 from "./tianbaoxiangqingLess.vue?vue&type=style&index=0&id=5a5bcb91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5bcb91",
  null
  
)

export default component.exports